import {constant} from "../utils/index.js";

import {default as Plot} from "./Plot.js";

/**
    Creates a line plot based on an array of data.
    @example <caption>the equivalent of calling:</caption>
new d3plus.Plot()
  .discrete("x")
  .shape("Line")
*/
export default class LinePlot extends Plot {
  /**
      Invoked when creating a new class instance, and overrides any default parameters inherited from Plot.
      @private
  */
  constructor() {
    super();
    this._discrete = "x";
    this._shape = constant("Line");
  }
}
